const set = require('regenerate')(0x951, 0x1CD7, 0x1CD9, 0x1CE0, 0x1CEA, 0x1CED, 0xA838);
set.addRange(0x1CDC, 0x1CDD).addRange(0xA830, 0xA835).addRange(0x11180, 0x111DF).addRange(0x11B60, 0x11B67);
exports.characters = set;
